import { dataVideoCropSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoCropSolid = /*#__PURE__*/createIcon(dataVideoCropSolid)
export default IconVideoCropSolid
